<template>
  <div>
    <h2 class="margin-top-off size-18 upper weight-normal color-gray-light-mid">
      <span class="upper">{{ direction }}</span>&nbsp;<strong class="color-gray-dark weight-normal">{{ segments[0].departure | dateToMonthday }}</strong>
    </h2>
    <div class="row">
      <p class="col-xs-3 text-left min-line-height">
        <span class="size-18">{{ segments[0].departure | dateToHour }}</span><br>
        <span class="size-16 weight-mid color-gray-light-mid">{{ segments[0].origin }}</span><br>
        <span class="size-12 weight-normal">{{ segments[0].origin_city }}</span><br>
      </p>
      <div class="col-xs-6 text-center _pr-0 _pl-0">
        <div class="hour-mark">
          <i class="fa fa-plane fa-fw ico-plane"></i>
        </div>
        <p class="size-14">
          <!-- <span class="weight-lighter">{{ 'voos' | pluralize(segments.length) }}:</span> -->
          <span
            v-for="(segment, index) in segments"
            :key="`flight-hourly-fligh-number-${index}`">
            {{ segment.airline.iata }} {{ segment.flight_number | normalizeFlightNumber }}
          </span>
        </p>
      </div>
      <p class="col-xs-3 text-right min-line-height">
        <span class="size-18">{{ segments[segments.length - 1].arrival | dateToHour }}<sup v-if="dateDiffArrival > 0" class="color-magenta">+{{ dateDiffArrival }}</sup></span><br>
        <span class="size-16 weight-mid color-gray-light-mid">{{ segments[segments.length - 1].destination }}</span><br>
        <span class="size-12 weight-normal">{{ segments[segments.length - 1].destination_city }}</span><br>
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: [
    'segments'
  ],
  computed: {
    direction () {
      return this.segments[0].direction === 'outbound' ? 'ida' : 'volta'
    },
    dateDiffArrival () {
      return moment(this.segments[this.segments.length - 1].arrival, 'YYYY, MM, DD').diff(moment(this.segments[0].departure, 'YYYY, MM, DD'), 'days')
    }
  }
};
</script>
